//just static compenent shouldn't be client.
//'client-use';
import classes from './styles.module.scss';
import { ITypography } from './typography.types';

const Typography = ({
    variant = '',
    style,
    children,
    color,
    className = '',
    component = '',
}: ITypography) => {
    const isDevEl = component === 'div';
    const isPEl = component === 'p' || component === '';
    const isSpanEl = component === 'span';
    const isH1El = component === 'h1';
    const isH2El = component === 'h2';
    const isH3El = component === 'h3';
    const isH4El = component === 'h4';
    const isH5El = component === 'h5';
    const isH6El = component === 'h6';

    const _style = color ? { ...style, color } : style;

    return (
        <>
            {isPEl && (
                <p
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </p>
            )}
            {isDevEl && (
                <div
                    style={_style}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </div>
            )}
            {isSpanEl && (
                <span
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </span>
            )}
            {isH1El && (
                <h1
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </h1>
            )}
            {isH2El && (
                <h2
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </h2>
            )}
            {isH3El && (
                <h3
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </h3>
            )}
            {isH4El && (
                <h4
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </h4>
            )}
            {isH5El && (
                <h5
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </h5>
            )}
            {isH6El && (
                <h6
                    style={{ ..._style }}
                    className={`${classes[variant]} ${className}`}
                >
                    <>{children}</>
                </h6>
            )}
        </>
    );
};
export default Typography;
